var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-item",on:{"click":_vm.goPage}},[_c('img',{attrs:{"src":_vm._f("imageToWebp")(_vm._f("imageToHttps")(_vm.data.mainPicture),_vm.$webpSurpport),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }